import { Box, Typography } from "@mui/material";

type Props = {
  required?: boolean;
  label?: string;
  alignLabel?: boolean;
  className?: string;
  children: React.ReactNode;
};

export function InputContainer({
  required = false,
  label,
  alignLabel = false,
  children,
  className,
}: Props) {
  return (
    <Box
      sx={{
        width: "100%",
        margin: "0.5em 0",
        display: "flex",
        flexDirection: alignLabel ? "row" : "column",
        alignItems: alignLabel ? "center" : "flex-start",
        gap: alignLabel ? "0.5em" : 0,
        ...(className && { className }),
      }}
    >
      {label && (
        <Typography
          component="label"
          sx={{
            fontWeight: 600,
            fontSize: 14,
            marginBottom: alignLabel ? 0 : "0.5em",
            whiteSpace: alignLabel ? "nowrap" : "normal",
            marginRight: alignLabel ? "0.5em" : 0,
            display: "flex",
            alignItems: "center",
            userSelect: "none",
          }}
        >
          {required && (
            <Box component="span" sx={{ color: "red", mr: "0.2em" }}>
              *
            </Box>
          )}
          <Box component="span">{label}</Box>
          <Box component="span" sx={{ mx: "0.3em" }}>
            :
          </Box>
        </Typography>
      )}

      <Box
        className="input"
        sx={{
          flex: alignLabel ? 1 : "unset",
          width: alignLabel ? "auto" : "100%",
          color: "#000",
          borderRadius: 1, // 4px
          border: 0,
          outline: 0,
          fontSize: 14,
          paddingLeft: "1em",
          "&::after": {
            content: '""', // unset content
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
